import { Component, EventEmitter, Inject, OnInit, Output, Input, ViewChild, PipeTransform, Pipe } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { WarningBoxComponent } from 'src/app/components';
import { SupplierPickupReturnContainersComponent } from 'src/app/components/external-dashboards/supplier-pickup-return-containers/supplier-pickup-return-containers.component';
import { ContainerInfo, ContainerPickupInfo } from 'src/app/models/do-container-reference';
import { ReleaseOrderService } from 'src/app/services/release-order.service';
import { ContainerOffHireService } from '../container-off-hire.service';
import { ContainerOffHireClass } from '../container-off-hire';

@Pipe({ name: "errorsToolTip" })
export class ErrorTooltipListPipe implements PipeTransform {
  constructor() { }

  transform(lines: any): string {
    let list: string = "";

    lines.forEach(line => {
      list += `• ${line} \n`;
    });

    return list;
  }
}
@Component({
  selector: 'logzy-validate-off-hire-container',
  templateUrl: './validate-off-hire-container.component.html',
  styleUrls: ['./validate-off-hire-container.component.scss']
})
export class ValidateOffHireContainerComponent implements OnInit {

  @Output() offHiredContainerSaved = new EventEmitter<void>();
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<ContainerInfo>;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50, 100];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  containerPickup: ContainerPickupInfo = null;
  containers: string = '';
  errorObj: any = {};
  disableSave: boolean = false;
  @Input() loading: boolean = false;
  containerList: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private releaseservice: ReleaseOrderService,
    public dialogRef: MatDialogRef<SupplierPickupReturnContainersComponent>,
    private dialog: MatDialog, private containerOffHireService: ContainerOffHireService) { }

  ngOnInit(): void {
    console.log('Received Data', this.data.data);

    // this.data.data.sort(function (x, y) {
    //   return (x.has_errors === y.has_errors) ? 0 : x.has_errors ? -1 : 1;
    // });
    this.dataSource = new MatTableDataSource(this.data?.data);
    this.displayedColumns = ['container_number', 'size', 'drop_off_date', 'drop_off_depot', 'return_order', 'use_req_no', 'mnr_status', 'supplier_name', 'errors', 'action'];
  }
  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }


  showErrors(row: ContainerInfo) {
    // console.log(row);
    if (row.has_errors) {
      return row.errors;
    }
  }
  removeContainer(container: ContainerInfo) {
    this.dataSource.data = this.dataSource.data.filter(item => item.container_number != container.container_number);
  }
  postOffhireContainers() {
    this.containers = '';
    this.dataSource.data.map(item => {
      if (!item.has_errors) {
        this.containers += item.container_number + ',';
      }
    });
    if (this.containers == '') {
      this.openWarning('No valid containers are available for Off-hire !!!!!', '', 'I Understand');
      this.disableSave = false;
    } else {
      this.loading = true;
      this.data.containerOffhireObject['container_numbers'] = this.containers.substring(0, this.containers.lastIndexOf(',')),
        // Remove the last comma (if any) and split into an array
        this.containerList = this.containers
          .replace(/,$/, '')
          .split(',');
      this.containerOffHireService.postOffHireContainer(this.data.containerOffhireObject).subscribe({
        next: response => {
          this.dialogRef.close();
          this.offHiredContainerSaved.emit(response);
        },
        error: error => {
          return this.catchError(error);
        }
      })
    }
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

}
